import { jsxs as r, jsx as o, Fragment as m } from "react/jsx-runtime";
import { memo as v, useMemo as F } from "react";
import { Confirm as b, MdView as j } from "@biron-data/react-components";
import { Row as w, Col as l, Button as p } from "antd";
import { u as s } from "./styled-components.browser.esm-BFmoFexH.js";
import { useLanguageResolver as z } from "@biron-data/react-contexts";
import { useColumnLayout as i } from "./selector/metrics/hooks.js";
import { useSelectorLayout as L } from "./layout/useSelectorLayout.js";
const q = v(({
  altSubmit: t,
  altDefault: c,
  submitting: f,
  cancel: u,
  submit: d,
  hasHelp: g = !0,
  $hasmargin: h = !1
}) => {
  const n = z(), e = L(), x = i(e, "none", 6, 1), y = i(e, "auto", 13, 3), C = i(e, "none", 1), a = F(() => e === "compact" ? "small" : "middle", [e]);
  return /* @__PURE__ */ r(k, { children: [
    /* @__PURE__ */ r(w, { className: "button-list", wrap: !1, children: [
      /* @__PURE__ */ r(l, { ...x, children: [
        t ? /* @__PURE__ */ o(b, { ...t.confirm, trigger: t.trigger }) : null,
        c || /* @__PURE__ */ o(m, {})
      ] }),
      /* @__PURE__ */ r(P, { ...y, $hasmargin: h ? 1 : 0, children: [
        /* @__PURE__ */ o(p, { onClick: u, size: a, children: n.get("button-cancel") }, 0),
        /* @__PURE__ */ o(p, { type: "primary", loading: f, onClick: d, size: a, children: n.get("button-apply") }, 1)
      ] }),
      /* @__PURE__ */ o(l, { ...C })
    ] }),
    g ? /* @__PURE__ */ o(M, { children: /* @__PURE__ */ o(j, { description: n.get("configuration-footer-help") }) }) : /* @__PURE__ */ o(m, {})
  ] });
}), P = s(l)`
    display: flex;
    justify-content: flex-end;
    gap: 8px;

    ${({ $hasmargin: t }) => t ? `
  button {
    margin-left: 10px;
  }
  ` : ""}
`, k = s.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`, M = s.div`
    a, .configuration-footer-help a:hover {
        color: var(--light-grey);
    }
`;
export {
  q as default
};
//# sourceMappingURL=FormFooter.js.map
